export default __webpack_public_path__ + "static/media/logo-escale-sante.c2646634.jpg";